<template>
  <div>
    <!-- :get-form-data="fromData" -->
    <!--       :reset-data-func="api.list" -->
    <!--   @check-change="checkChange" -->
    <list
      row-key="PromotionalPriceId"
      ref="list"
      unit="促销价格"
      :page="page"
      show-checkbox
      :show-query="false"
      :query-params="params"
      :get-data-func="getDataFunc"
      urlHash="business/sales/salemanage/promotion"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="table">
        <slot name="column"></slot>
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/trend/list";
import list from "@/components/common/trendsTable/list";
// import tableColumn from "@/data/business/sales/salemanage/promotion/list.json";
// import tableParam from "@/data/production/craftsmanship/solutions/mold/query.json";

export default {
  mixins: [listMixin],
  components: { list },
  data() {
    return {
      api: require("@/api/sa/promotionalPrice").default,
      productApi: require("@/api/ba/product").default,
      mouldApi: require("@/api/ba/mould").default,
      params: {
        MouldNo: "",
        SolutionsName: "",
      },
      mouldOption: [],
      ids: [],
    };
  },

  methods: {
   
    getDataFunc() {
      
      return new Promise((resolve) => {
        console.log('我执行了');
        this.api.list({}).then((res) => {
          resolve(res);
        });
      });
    },
    review(data) {
      this.api.review(data.PromotionalPriceId).then((res) => {
        if (res.Code == 0) {
          this.$message.success("审核成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
    back(data) {
      this.api.back(data.PromotionalPriceId).then((res) => {
        if (res.Code == 0) {
          this.$message.success("已弃审");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
    updateStatus(data) {
      this.api
        .changeDeactivate({
          Id: data.PromotionalPriceId,
          IsDeactivate: !data.IsDeactivate,
        })
        .then((res) => {
          if (res.Code == 0) {
            this.$message.success("已弃审");
            this.reload();
          } else {
            this.$message.error(res.Msg);
          }
        });
    },
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
  },
};
</script>
